import React from 'react';
import Normalization from './Normalization';
import NormalizationHeader from './NormalizationHeader';
import {PageLayout} from '../../components';

function NormalizationContainer() {
  return (
    <PageLayout>
      <PageLayout.Header>
        <NormalizationHeader />
      </PageLayout.Header>
      <PageLayout.Content>
        <Normalization />
      </PageLayout.Content>
    </PageLayout>
  );
}

export default NormalizationContainer;
